import { useLayoutEffect } from "react";
import { useFrame, useThree } from "@react-three/fiber";
import * as THREE from "three";
import useStore from "../store";
import { degToRad } from "three/src/math/MathUtils";

export default function CameraCustom() {
  const flymode = useStore(state => state.flymode)
  const frameTime = useStore(state => state.frameTime)
  const cell = useStore((state) => state.station) - 1;
  const i = cell === -1 ? -1 : cell - Math.floor(cell / 17) * 17;

  const x = 190 * Math.sin(degToRad((360 / 17) * i));
  const y = 1;
  const z = 190 * Math.cos(degToRad((360 / 17) * i));

  const newPoint2 =
    i === -1
      ? new THREE.Vector3(12, 19, 200)
      : new THREE.Vector3(x, y + 15, z);

  let { camera, gl } = useThree();

  useLayoutEffect(() => {
    if (flymode) return camera.position.set(0, 60, 0);
    camera.position.set(0, 60, 250);
    gl.outputEncoding = THREE.sRGBEncoding
    gl.toneMapping = THREE.LinearToneMapping
  }, [])

  useFrame(({ camera, clock }, delta) => {
    if (flymode) return
    camera.position.lerp(newPoint2, frameTime * 0.008 * 115);
    camera.updateProjectionMatrix();
  });

  

  return null;
}
